import React, { useEffect, useState } from "react";
import { Stack } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import OTPInput, { ResendOTP } from "otp-input-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Stox from "../../pics/stoxkart_old_logo.png";
import logo from '../../assets/stox.png'
import SideImg from '../../assets/Asset 1 2.svg';
import { useContext } from "react";
import { Context } from "../../Context/GlobalContext";

const VerifyLogin = () => {
  // const { mobiEmail } = useContext(Context)
  const [OTP, setOTP] = useState("");
  const [error, setError] = useState("");
  const [verify, setVerify] = useState("");
  // const [isAuth, setAuth] = useState(sessionStorage.getItem("userCode"));
  const userCode = localStorage.getItem("userCode");
  const navigate = useNavigate();
  const URL = process.env.REACT_APP_BASE_URL;
  const mobiEmail = sessionStorage.getItem("mobiEmail")

  const sendOtp = async () => {
    try {
      setOTP("");
      await axios.post(`${URL}/Login/sendOTP`, { userCode: userCode });
    } catch (error) {
      console.log("error in send otp", error);
    }
  };

  const verifyOtp = async () => {
    try {
      setVerify("OTP Verifying.....");
      await axios.post(`${URL}/Login/verifyOTP`, {
        userCode: userCode,
        userOtp: OTP,
      }, { withCredentials: true });
      sessionStorage.setItem("userCode", userCode);
      navigate("/main");
    } catch (error) {
      setError(error.response.data.result.flagMsg);
      setVerify("");
    }
  };

  useEffect(() => {
    const keyDownHandler = event => {
      if (event.key === 'Enter') {
        verifyOtp();
      }
    };
    document.addEventListener('keydown', keyDownHandler);
    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [OTP]);

  // useEffect(() => {
  //   console.log(isAuth);
  //   if (isAuth) {
  //     navigate("/main");
  //   }
  // }, []);

  return (
    <>
      <Stack direction="horizontal">
      <div className="left_panel1" style={{background: '#DCEBFB', height: '100vh', padding: '90px 65px 0px 0px'}}>
          <img src={logo} alt="logo"  width='100px' style={{    position: 'absolute', top: 10, left: 10}}/>
          <img
            src={SideImg}
            alt="left_pan_img"
            style={{ width: "40vw", height: "60vh" }}
          />
          <h3 style={{textAlign: 'center', marginTop: 20}}>Re-KYC with Stoxkart</h3>
          <p style={{textAlign: 'center'}}>Verify yourself with Re-KYC and re-connect with Stoxkart</p>
        </div>
      {/* <div className="left_panel1" style={{background: '#DCEBFB', height: '100vh'}}>
        <img src={logo} alt="logo"  width='100px' style={{    position: 'absolute', top: 10, left: 10}}/>
          <img
            src={SideImg}
            alt="left_pan_img"
            style={{ width: "45vw", height: "100vh" }}
          />
        </div> */}
        <div className="right_panel">
          <div className="img_logo">
            <img
              src={Stox}
              alt="/"
              style={{ width: 330, margin: "20px 20px 20px auto" }}
            />
          </div>
          {/* <h1>Hello Again</h1>
          <p style={{ fontSize: 10 }}>
          Missed us? Well, we definitely missed you so let us connect again. Resume your trading with us in few simple steps!
          </p> */}
          <h3>Verify OTP</h3>
          <p style={{ fontSize: 12 }}>OTP has been sent to <span style={{fontWeight: 'bold', fontSize: 11}}>{mobiEmail}</span>  </p>
          <div className={error ? "otp_wrapper_red" : "otp_wrapper"}>
            <OTPInput
              value={OTP}
              onChange={
                error
                  ? () => {
                      setError("");
                    }
                  : setOTP
              }
              autoFocus
              OTPLength={6}
              otpType="number"
              disabled={false}
              placeholder={["-", "-", "-", "-", "-", "-"]}
            />
          </div>
          <div className="resend_btn" style={{ display: "flex" }}>
            <p style={{ fontSize: "12px", marginTop: 20, marginBottom: 20 }}>
              Didn't receive the OTP?{" "}
            </p>
            <ResendOTP
              maxTime="20"
              className="resend_btn"
              style={{
                fontSize: "12px",
                margin: "20px 0px 10px 10px",
                display: "flex",
                gap: 5,
              }}
              onResendClick={sendOtp}
            />
          </div>
          <p style={{ color: "red", fontSize: 12 }}>{error ? error : null}</p>
          <div className="d-grid gap-2 mt-4">
            <Button
              disabled={OTP.length != 6}
              style={{ backgroundColor: "#05BB75", border: "none" }}
              size="md"
              onClick={verifyOtp}
            >
              {verify ? verify : "Verify OTP"}
            </Button>
          </div>
        </div>
      </Stack>
    </>
  );
};

export default VerifyLogin;
